<template>
  <div id="app-integration">
    <b-card
      v-if="value.status !== 1"
      class="block-test-mode"
      no-body
    >
      <b-card-body style="padding: 0.857rem 1.214rem;">
        <div class="text-test-mode">
          <b-img
            :src="require('@/assets/images/icons/fi_info.svg')"
            style="position: absolute; transform: translate(0, -50%); top: 50%; left: 1.214rem; width: 1.214rem;"
          />
          <span style="display: inline-block; margin-left: 2.143rem; line-height: 130%;">
            {{ $t('apps.yourAppIsTestMode') }}
            <template v-if="value.status === 2">
              <br>{{ $t('apps.ourTeamIsReviewingYourIntegration') }}
            </template>
          </span>
        </div>
        <b-button
          v-if="value && value.status === 0"
          id="go-live-btn"
          :variant="btnGoliveVariant"
          @click="onClickRequestGolive"
        >
          {{ $t('apps.requestToGoLive') }}
        </b-button>
        <b-tooltip
          v-if="btnGoliveVariant === 'secondary'"
          target="go-live-btn"
          placement="bottom"
          triggers="hover"
        >
          {{ $t('apps.pleaseCompleteTheAppSetupFirst') }}
        </b-tooltip>
      </b-card-body>
    </b-card>
    <div class="detail-offer-wall">
      <validation-observer
        ref="main_form"
        v-slot="{ validated }"
      >
        <b-row>
          <b-col cols="12">
            <b-row>
              <b-col>
                <div
                  class="offer-info-block p-1"
                  style="border-left-width: 0.357rem !important;"
                >
                  <b-row>
                    <b-col
                      cols="12"
                      class="mb-2"
                      style="padding-bottom: 0.857rem;"
                    >
                      <b-media no-body>
                        <b-media-aside class="mr-1">
                          <b-avatar
                            size="32"
                            variant="light-primary"
                          >
                            <feather-icon
                              size="16"
                              icon="CornerDownLeftIcon"
                            />
                          </b-avatar>
                        </b-media-aside>
                        <b-media-body class="my-auto mt-2">
                          <div class="offer-info-block-title">
                            {{ $t('apps.redirects') }}
                          </div>
                          <div class="offer-info-block-des">
                            {{ $t('apps.definesWhatHappensWhenReturnFromASurvey') }}
                          </div>
                        </b-media-body>
                      </b-media>

                      <hr
                        class="mt-2"
                        style="margin: 0;"
                      >
                    </b-col>

                    <b-col cols="12">
                      <b-form-group>
                        <b-form-radio-group
                          v-model="selectedRedirectOption"
                          name="redirectOption"
                        >
                          <b-row class="mb-1">
                            <b-col
                              cols="6"
                              style="padding-right: 2.286rem; border-right: 0.143rem solid #ddd;"
                            >
                              <b-form-radio value="primeSurveys">
                                {{ $t('apps.redirectToPrimeSurveysSurveywallRecommended') }}
                              </b-form-radio>
                            </b-col>
                            <b-col
                              cols="6"
                              style="padding-left: 2.286rem;"
                            >
                              <div class="currency-description">
                                {{ $t('apps.redirectToIframeUrlWhereUsersCanTakeMore') }}
                              </div>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              cols="6"
                              style="padding-right: 2.286rem; border-right: 0.143rem solid #ddd; height: 70px;"
                            >
                              <b-form-radio value="customUrl">
                                {{ $t('apps.redirectToAnotherUrl') }}
                              </b-form-radio>

                              <validation-provider
                                v-slot="{ errors }"
                                :name="$t('apps.redirectUrl')"
                                vid="Redirect URL"
                                :rules="{ required: selectedRedirectOption === 'customUrl' }"
                              >
                                <b-input
                                  v-if="selectedRedirectOption === 'customUrl'"
                                  v-model="redirect_url"
                                  class="mx-2 mt-1"
                                />

                                <small
                                  v-if="selectedRedirectOption === 'customUrl' && validated && errors.length > 0"
                                  class="ml-2 text-danger"
                                >{{ errors[0] }}</small>
                              </validation-provider>
                            </b-col>
                            <b-col
                              cols="6"
                              style="padding-left: 2.286rem;"
                            >
                              <div class="currency-description">
                                {{ $t('apps.redirectBackToYourAppOrWebsite') }}<br>
                                {{ $t('apps.youMustShowTheUserTheOutcomeCompleteAnd') }}
                              </div>
                            </b-col>
                          </b-row>
                        </b-form-radio-group>
                        <b-row
                          v-show="selectedRedirectOption === 'customUrl'"
                          class="mt-2"
                        >
                          <b-col
                            class="mt-1"
                            cols="6"
                          >
                            <b-media no-body>
                              <b-media-aside class="mr-1">
                                <b-avatar
                                  size="32"
                                  variant="light-primary"
                                >
                                  <feather-icon
                                    size="16"
                                    icon="HashIcon"
                                  />
                                </b-avatar>
                              </b-media-aside>
                              <b-media-body
                                class="my-auto"
                              >
                                <div class="offer-info-block-title">
                                  {{ $t('apps.urlHashing') }}
                                </div>
                                <div class="block-warning-unique-id mt-50">
                                  <div>
                                    <b-img
                                      :src="require('@/assets/images/icons/fi_info.svg')"
                                      style="position: absolute;transform: translate(0, -50%);top: 50%; left: 1.214rem; width: 1.75rem;"
                                    />
                                    <div style="display: inline-block; margin-left: 2.5rem; margin-bottom: 0.5rem;">
                                      {{ $t('apps.recommendUrlHashing') }}<br>
                                      {{ $t('apps.usersCanOtherwiseManipulateTheResultsAndAmountIn') }}<br>
                                      {{ $t('apps.ifYouArePayingUsersBasedOnPostbackCalls') }}
                                    </div>
                                  </div>
                                </div>
                              </b-media-body>
                            </b-media>

                            <b-row
                              class="mt-1"
                              style="height: 50px;"
                            >
                              <b-col cols="6">
                                <b-form-checkbox v-model="urlHashingEnabled">
                                  {{ $t('apps.enableUrlHashingFullUrl') }}
                                </b-form-checkbox>

                                <b-form-checkbox
                                  v-if="urlHashingEnabled"
                                  v-model="hashQueryString"
                                  class="ml-1 mt-1"
                                >
                                  {{ $t('apps.hashOnlyQueryString') }}
                                </b-form-checkbox>
                              </b-col>
                              <b-col cols="6">
                                <b-form-group
                                  v-if="urlHashingEnabled"
                                  :label="$t('apps.secret')"
                                >
                                  <b-form-input
                                    :value="value.security_hash_salt"
                                    readonly
                                  />
                                </b-form-group>
                              </b-col>
                            </b-row>

                            <b-form-group
                              v-if="urlHashingEnabled"
                              class="mt-1"
                            >
                              <label class="font-small-4">
                                <i18n
                                  path="apps.appendRedirectHash"
                                  tag="span"
                                >
                                  <b slot="hash">hash</b>
                                </i18n>
                              </label>
                              <b-form-input
                                :value="isValidRedirectUrl ? `${generateExampleUrl()}&hash=${generatedHash}` : ''"
                                readonly
                              />
                            </b-form-group>

                            <b-form
                              v-if="urlHashingEnabled"
                              inline
                              class="mt-1"
                            >
                              <label class="font-small-4 font-weight-bold mr-2">
                                {{ $t('apps.calculationExample') }}
                              </label>
                              <b-form-textarea
                                style="width: 75%"
                                :value="isValidRedirectUrl
                                  ? (
                                    hashQueryString
                                      ? `hash = sha1(query-string-without-hash${urlHashingEnabled ? ' + secret' : ''})\n` +
                                        `hash = sha1(${generateQueryStringWithoutHash()}${urlHashingEnabled ? value.security_hash_salt : ''})\n` +
                                        `hash = ${generatedHash}`
                                      : `hash = sha1(url-without-hash${urlHashingEnabled && !hashQueryString ? ' + secret' : ''})\n` +
                                        `hash = sha1(${generateExampleUrl()}${urlHashingEnabled && !hashQueryString ? value.security_hash_salt : ''})\n` +
                                        `hash = ${generatedHash}`
                                  )
                                  : 'hash = sha1(url-without-hash)'"
                                readonly
                                class="calculation-example-text"
                                rows="5"
                              />

                            </b-form>
                          </b-col>

                          <b-col
                            cols="6"
                            style="padding-bottom: 0.857rem;"
                          >
                            <b-col
                              cols="6"
                              style="padding-bottom: 0.857rem;"
                              align-self="center"
                            >
                              <div class="offer-info-block-title">
                                {{ $t('apps.availableParameters') }}
                              </div>
                            </b-col>
                            <b-col cols="12">
                              <table class="table b-table table-striped table-hover border">
                                <thead>
                                  <tr>
                                    <th>{{ $t('apps.parameter') }}</th>
                                    <th>{{ $t('apps.type') }}</th>
                                    <th>{{ $t('apps.description') }}</th>
                                  </tr>
                                </thead>
                                <tbody role="rowgroup">
                                  <tr
                                    v-for="(tr, indextr) in supportedParameters"
                                    :key="indextr"
                                    @click="addParameter(tr)"
                                  >
                                    <td style="cursor: pointer">
                                      {{ supportedParameters[indextr].key }}
                                    </td>
                                    <td>{{ supportedParameters[indextr].type }}</td>
                                    <td>
                                      {{ supportedParameters[indextr].description }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </b-col>
                          </b-col>
                        </b-row>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <div class="block-attention">
                  {{ $t('apps.ifYouReRedirectingToAPageThatLoads', { clickId: '{cid}' }) }}
                  <br>
                  {{ $t('apps.thenPassItOntoTheIframeOrScriptTag') }}
                </div>
              </b-col>
            </b-row>

            <b-row class="mb-1 mt-2">
              <b-col>
                <div
                  class="offer-info-block p-1"
                  style="border-left-width: 0.357rem !important;"
                >
                  <b-media no-body>
                    <b-media-aside class="mr-1">
                      <b-avatar
                        size="32"
                        variant="light-primary"
                      >
                        <feather-icon
                          size="16"
                          icon="CodeIcon"
                        />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body class="my-auto">
                      <div class="offer-info-block-title">
                        {{ $t('apps.scriptTag') }}
                      </div>
                      <p class="offer-info-block-des">
                        {{ $t('apps.theScriptTagWillShowAnIconOnThe') }}
                      </p>
                    </b-media-body>
                  </b-media>
                  <div class="code-copy-block">
                    <div
                      class="button-copy bg-primary"
                      @click="copyText(integration_script)"
                    >
                      <span>{{ $t('apps.copy') }}</span></div>
                    <div class="code-content bg-light-primary">
                      <pre class="code-block"><span class="hljs-tag">&lt;<span
                        class="hljs-name"
                        style="font-weight: 700;"
                      >script</span> <span
                        class="hljs-attr"
                      >type</span>=<span
                        class="hljs-string"
                        style="color: rgb(136, 0, 0);"
                      >"text/javascript"</span>&gt;</span><span
                          class="actionscript"
                      >{<span
                          class="hljs-keyword"
                          style="font-weight: 700;"
                      >var</span> primeSurveysConfig = {app: <span
                          class="hljs-string"
                          style="color: rgb(136, 0, 0);"
                      >"{{
                          app_hash
                        }}"</span>, uuid: <span
                          class="hljs-string"
                          style="color: rgb(136, 0, 0);"
                      >"UNIQUE-USER-ID"</span>, cid: <span
                          class="hljs-string"
                          style="color: rgb(136, 0, 0);"
                      >"CID"</span>}}</span><span
                          class="hljs-tag"
                      >&lt;/<span
                          class="hljs-name"
                          style="font-weight: 700;"
                      >script</span>&gt;</span><br><span
                          class="hljs-tag"
                      >&lt;<span
                          class="hljs-name"
                          style="font-weight: 700;"
                      >script</span> <span
                          class="hljs-attr"
                      >src</span>=<span
                          class="hljs-string"
                          style="color: rgb(25, 61, 245);"
                      >"{{ base_url }}/primewidget.js"</span>/&gt;</span><span
                          class="undefined"
                      /><span class="hljs-tag">&lt;/<span
                          class="hljs-name"
                          style="font-weight: 700;"
                      >script</span>&gt;</span></pre>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-1">
              <b-col>
                <div
                  class="offer-info-block p-1"
                  style="border-left-width: 0.357rem !important;"
                >
                  <b-media no-body>
                    <b-media-aside class="mr-1">
                      <b-avatar
                        size="32"
                        variant="light-primary"
                      >
                        <feather-icon
                          size="16"
                          icon="FramerIcon"
                        />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body class="my-auto">
                      <div class="offer-info-block-title">
                        {{ $t('apps.iframe') }}
                      </div>
                      <p class="offer-info-block-des">
                        {{ $t('apps.theIframeCanBeIntegratedToASeparatePage') }}
                      </p>
                    </b-media-body>
                  </b-media>

                  <div class="code-copy-block">
                    <div
                      class="button-copy bg-primary"
                      @click="copyText(integration_iframe)"
                    >
                      <span>{{ $t('apps.copy') }}</span></div>
                    <div class="code-content bg-light-primary">
                      <pre class="code-block"><span class="hljs-tag">&lt;<span
                        class="hljs-name"
                        style="font-weight: 700;"
                      >iframe</span> <span
                        class="hljs-attr"
                      >src</span>=<span
                        class="hljs-string"
                        style="color: rgb(25 61 245);"
                      >"{{ base_url }}/?app=<span
                        style="color: rgb(136, 0, 0);"
                      >{{ app_hash }}</span>&amp;uuid=<span
                        style="color: rgb(136, 0, 0);"
                      >UNIQUE-USER-ID</span>&amp;cid=<span
                        style="color: rgb(136, 0, 0);"
                      >CID</span><span
                        class="hljs-string"
                        style="color: rgb(25 61 245);"
                      >&amp;network=&amp;source=&amp;placement=</span>"</span>&gt;</span><span class="hljs-tag">&lt;/<span
                        class="hljs-name"
                        style="font-weight: 700;"
                      >iframe</span>&gt;</span></pre>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import i18n from '@/libs/i18n'

/* eslint-disable no-useless-escape,no-useless-concat */
import { ValidationObserver, ValidationProvider } from 'vee-validate/dist/vee-validate.full'

export default {
  name: 'AppEditRedirects',
  components: { ValidationObserver, ValidationProvider },
  props: [
    'value',
  ],
  data() {
    return {
      selectedRedirectOption: this.value.redirect_url ? 'customUrl' : 'primeSurveys',
      urlHashingEnabled: [1, 2].includes(this.value.redirect_hash_type),
      hashQueryString: this.value.redirect_hash_type === 2,
      integration_script: '',
      integration_iframe: '',
      base_url: null,
      app_hash: null,
      redirect_url: this.value.redirect_url || '',
      supportedParameters: [
        { key: '{result}', type: 'Integer', get description() { return i18n.t('apps.1Complete2Screenout') } },
        {
          key: '{cid}',
          type: 'String',
          get description() { return i18n.t('apps.primeSurveysUniqueIdPassToTheIframeTo') },
        },
        { key: '{subid}', type: 'String', get description() { return i18n.t('apps.returnsTheSubid') } },
        { key: '{reward}', type: 'Integer', get description() { return i18n.t('apps.theRewardAmountCreditedToYourUsers') } },
        { key: '{user}', type: 'Integer', get description() { return i18n.t('apps.theUserId') } },
        { key: '{payout}', type: 'Float', get description() { return i18n.t('apps.theRevenueGenerated') } },
      ],
      generatedHash: '',
      redirectUrlOld: '',
    }
  },
  computed: {
    btnGoliveVariant() {
      let isValidReward = false
      if (this.value.reward_type !== 0) isValidReward = true
      else if (this.value.fixed_reward) isValidReward = true
      if (this.value.currency_exchange_rate && this.value.currency_name && isValidReward) return 'primary'
      return 'secondary'
    },
    isValidRedirectUrl() {
      if (!this.redirect_url) {
        return false
      }

      const urlPattern = new RegExp(
        '^(https?:\\/\\/)?' // Protocol
          + '((([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,})|' // Domain name and extension
          + 'localhost|' // localhost
          + '\\d{1,3}(\\.\\d{1,3}){3})' // OR IP address (IPv4)
          + '(\\:\\d+)?(\\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?' // Port and path
          + '(\\?[;&a-zA-Z0-9%_+.~#?&=]*)?' // Query string
          + '(\\#[-a-zA-Z0-9@:%_+.~#?&//=]*)?$', // Fragment locator
      )

      // Remove placeholders like {result}, {cid}, {subid}, {reward} before validation
      const cleanedUrl = this.redirect_url.replace(/{\w+}/g, '')

      // Test the cleaned URL against the pattern
      return urlPattern.test(cleanedUrl)
    },
  },
  watch: {
    redirect_url: {
      handler() {
        const appData = this.value
        appData.redirect_url = this.redirect_url
        this.$emit('input', appData)
        this.generateHash()
      },
      immediate: true,
    },
    selectedRedirectOption(newValue) {
      if (newValue === 'primeSurveys') {
        this.redirectUrlOld = this.redirect_url
        this.redirect_url = null
        this.urlHashingEnabled = false
        this.hashQueryString = false
      } else {
        this.redirect_url = this.redirectUrlOld
      }
    },
    urlHashingEnabled(newValue) {
      this.value.redirect_hash_type = newValue ? 1 : 0
      this.hashQueryString = false
      this.$emit('input', this.value)
      this.generateHash()
    },
    hashQueryString(newValue) {
      if (this.urlHashingEnabled) {
        this.value.redirect_hash_type = newValue ? 2 : 1
        this.$emit('input', this.value)
        this.generateHash()
      }
    },
  },
  mounted() {
    window.AppEditIntegration = this
    this.app_hash = this.value.hash
    this.base_url = process.env.VUE_APP_SURVEY_BASE_URL
    const SURVEY_BASE_URL = process.env.VUE_APP_SURVEY_BASE_URL

    this.integration_script = `${'<script type="text/javascript">'
        + '{var primeSurveysConfig = {app: "'}${this.value.hash}", uuid: "UNIQUE-USER-ID"}}`
        + '<\/script>' + `\n<script src="${SURVEY_BASE_URL}/primewidget.js"/><\/script>`
    this.integration_iframe = `<iframe src="${SURVEY_BASE_URL}/?app=${this.value.hash}&uuid=UNIQUE-USER-ID&cid=CID&network=&source=&placement="></iframe>`
    this.redirect_url = this.value.redirect_url || ''
  },
  methods: {
    generateQueryStringWithoutHash() {
      const placeHoldersInUrl = this.replacePlaceholdersInUrl()
      if (placeHoldersInUrl === '') return ''

      const url = new URL(this.replacePlaceholdersInUrl())
      return url.search
    },
    generateExampleUrl() {
      return this.replacePlaceholdersInUrl()
    },
    replacePlaceholdersInUrl() {
      if (!this.redirect_url) {
        return ''
      }

      return this.redirect_url
        .replace('{result}', 1)
        .replace('{cid}', '61b1b253')
        .replace('{subid}', '12345')
        .replace('{reward}', 100)
        .replace('{user}', 6541)
        .replace('{payout}', 5.25)
    },
    generateHash() {
      let hashSource = ''

      if (this.urlHashingEnabled && !this.hashQueryString) {
        hashSource = this.generateExampleUrl()
      } else {
        hashSource = this.generateQueryStringWithoutHash()
      }

      hashSource += this.value.security_hash_salt

      // Check if crypto.subtle is available (only in secure contexts)
      if (!window.crypto || !window.crypto.subtle) {
        console.warn('crypto.subtle is not available. Hash generation requires HTTPS.')
        this.generatedHash = ''
        return
      }

      // Use the Web Crypto API to generate a SHA-1 hash
      const encoder = new TextEncoder()
      const data = encoder.encode(hashSource)

      window.crypto.subtle.digest('SHA-1', data).then(hashBuffer => {
        const hashArray = Array.from(new Uint8Array(hashBuffer))
        this.generatedHash = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('')

        // Force a UI update
        this.$forceUpdate()
      }).catch(err => {
        console.error('Hash generation failed:', err)
        this.generatedHash = ''
      })
    },
    requestToMakeAppLive() {
      this.showLoading()
      this.$http
        .post(`/api/app/${this.$route.params.appHash}/request-live`)
        .then(response => {
          const returnData = response.data
          if (returnData.status) {
            this.$emit('request-live', returnData.status)
            this.value.status = returnData.status
          }
        })
        .catch(errors => {
          this.alertApiError(errors, i18n.t('apps.requestToGoLiveFailed'))
        })
        .finally(() => {
          this.hideLoading()
        })
    },
    onClickRequestGolive() {
      if (this.btnGoliveVariant !== 'secondary') this.requestToMakeAppLive()
    },
    addParameter(param) {
      if (this.redirect_url && !this.redirect_url.includes(param.key)) {
        this.redirect_url += param.key
      }
    },
  },
}
</script>

<style scoped lang="scss">
#app-integration {
  .code-copy-block {
    position: relative;
    background: rgba(115, 103, 240, 0.12);
    border-radius: 0.429rem;
    overflow: hidden;

    & > .button-copy {
      width: 5.571rem;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      color: #FFF;
      text-align: center;
      cursor: pointer;

      span {
        position: absolute;
        transform: translate(-50%, -50%);
        top: 50%;
        left: 50%;
      }
    }

    & > .code-content {
      flex: 1;
      padding: 0.714rem;
      padding-left: 6.286rem;
    }
  }

  .code-block {
    display: block;
    white-space: initial;
    background: none;
    font-size: 1rem;
    margin-bottom: 0;
  }
}

#app-integration .code-copy-block > .code-content > pre > span {
  display: inline !important;
}

.tab-title-text {
  font-style: normal;
  font-weight: 600;
  font-size: 1.143rem;
  line-height: 1.429rem;
}

.tab-subtitle-text {
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 120%;
  width: 18.929rem;
}

.offer-info-block {
  background: #F8F8F8;
  border-radius: 0.429rem;
}

.offer-info-block-title {
  font-weight: 600;
  font-size: 1.071rem;
  line-height: 1.286rem;
  color: #5E5873;
}

.offer-info-block-des {
  width: 35.357rem;
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 120%;
  color: #6E6B7B;
}

.block-test-mode {
  background: rgba(234, 84, 85, 0.12);
  border-radius: 0.429rem;
  margin-bottom: 2.5rem;

  .text-test-mode {
    display: inline;
    margin-right: 2rem;
    font-weight: 500;
    font-size: 1rem;
    line-height: 120%;
    color: #EA5455
  }
}

.block-warning-unique-id {
  position: relative;
  background: rgba(234, 84, 85, 0.12);
  border-radius: 0.429rem;
  font-weight: 500;
  font-size: 1rem;
  line-height: 120%;
  color: #EA5455;
  padding: 0.857rem 1.214rem;
}

.offer-type-recommend {
  position: absolute;
  right: 0.714rem;
  color: #fff;
  top: -0.714rem;
  padding: 0.357rem 0.714rem;
  font-weight: 600;
  font-size: 0.857rem;
  line-height: 1.071rem;
  background: #6E6B7B;
  border-radius: 1.429rem;
}

.nav-link.active .offer-type-recommend {
  background: #7367F0;
}
</style>
<style>

[dir] .offer-type .nav-pills .nav-link {
  background: #FFFFFF;
  box-sizing: border-box;
  box-shadow: none;
  padding: 0.857rem;
  border-radius: 0.571rem;
}

[dir] .offer-type .nav-pills .nav-link.active {
  color: #7367F0;
  border: 1px solid #7367F0;
}

[dir] .offer-type.tabs .nav .nav-item {
  margin: 0 0.571rem !important;
  border-radius: 0.714rem !important;
}

svg.tab-title-icon {
  margin-right: 0 !important;
}

.offer-type .nav-link .tab-title-text {
  color: #6E6B7B;
}

.offer-type .nav-link.active .tab-title-text {
  color: #7367F0;
}

.block-attention {
  margin-top: 1.143rem;
  padding: 1.143rem;
  background: rgba(255, 159, 67, 0.12);
  border-radius: 0.429rem;
  font-size: 1rem;
  line-height: 140%;
}
</style>
